import { Button } from '@yes.technology/react-toolkit'
import useInterpolateUrl from '../../hooks/useInterpolateUrl'
import { ActionButton } from 'types/shared'

type Props = {
  actionButton: ActionButton
  disabled?: boolean
}

function DataFieldActionButton({ actionButton }: Props) {
  const interpolateUrl = useInterpolateUrl()
  const url = interpolateUrl(actionButton.url)

  return (
    <a
      href={url}
      target={actionButton.target || '_self'}
      rel='noopener noreferrer'
    >
      <Button heightClass='small' variant={actionButton.variant} tabIndex={-1}>
        {actionButton.des}
      </Button>
    </a>
  )
}

export default DataFieldActionButton
